/**
 * Phase 105-Agent-C — Agent self-pin on the AgentTasks map.
 *
 * Renders a single Leaflet marker for the agent's own position with a
 * soft accuracy circle when `accuracy_m > 50`. Hides itself when the
 * hook returns null lat/lng (agent paused or hasn't granted geo
 * permission yet).
 *
 * The pin uses a distinctive blue ring + white dot to stand out from
 * the order pickup pins (which are colored by lifecycle stage).
 */
import { Marker, Popup, L } from "../tracking/mapProvider";

const SELF_ICON = L.divIcon({
  className: "agent-self-pin",
  iconSize: [24, 24],
  iconAnchor: [12, 12],
  html: `
    <div style="
      width: 24px; height: 24px;
      display: flex; align-items: center; justify-content: center;
      pointer-events: auto;">
      <span style="
        width: 22px; height: 22px;
        border-radius: 50%;
        background: rgba(59, 130, 246, 0.25);
        position: absolute;"></span>
      <span style="
        width: 12px; height: 12px;
        border-radius: 50%;
        background: #3b82f6;
        border: 2px solid white;
        box-shadow: 0 1px 4px rgba(0,0,0,0.45);
        position: relative;"></span>
    </div>
  `,
});

export default function AgentPin({ lat, lng, accuracyM, paused, lastSentAt }) {
  if (lat == null || lng == null) return null;

  return (
    <Marker position={[lat, lng]} icon={SELF_ICON}>
      <Popup>
        <div className="text-xs font-sans" data-testid="agent-self-popup">
          <p className="font-semibold text-slate-900">You are here</p>
          <p className="text-[11px] text-slate-500 mt-0.5 font-mono">
            {lat.toFixed(5)}, {lng.toFixed(5)}
          </p>
          {accuracyM != null && (
            <p className="text-[11px] text-slate-500">±{Math.round(accuracyM)} m accuracy</p>
          )}
          {paused && (
            <p className="text-[11px] text-amber-700 mt-1">Live sharing paused — toggle online to resume.</p>
          )}
          {lastSentAt && (
            <p className="text-[10px] text-slate-400 mt-1">
              Last ping {new Date(lastSentAt).toLocaleTimeString()}
            </p>
          )}
        </div>
      </Popup>
    </Marker>
  );
}
